import { render, staticRenderFns } from "./smContact.vue?vue&type=template&id=794d045e&scoped=true&"
import script from "./smContact.vue?vue&type=script&lang=js&"
export * from "./smContact.vue?vue&type=script&lang=js&"
import style0 from "./smContact.vue?vue&type=style&index=0&id=794d045e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794d045e",
  null
  
)

export default component.exports